import styled, { css } from 'styled-components';

const NavigationSlideAnimation = styled.div `
  z-index: ${props => props.theme.zIndex.modal};
  position: ${props => (props.open ? 'relative' : 'absolute')};
  width: 100%;
  opacity: ${props => (props.open ? '1' : '0')};
  left: ${props => (props.open ? '0' : '-100%')};
  transition-property: opacity, left;
  transition-duration: ${props => props.theme.animation.duration.gentle1};
  transition-timing-function: ${props => props.open
    ? props.theme.animation.easing.expressive.entrance
    : props.theme.animation.easing.expressive.exit};

  @media screen and (min-width: ${props => props.theme.breakpoints.lg}) {
    z-index: ${props => props.theme.zIndex.overlay};
  }
`;
const NavigationContainer = styled.header `
  ${({ open }) => css `
    position: ${open ? 'fixed' : 'sticky'};
    overflow: ${open ? 'scroll' : 'visible'};
  `}

  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  // z-index: ${({ theme }) => theme.zIndex.overlay};
  // todo: revert custom zIndex after Video component redesign is completed
  z-index: 9001;
  background: ${({ theme }) => theme.colors.invertedTextColor};
  box-shadow: 0 -1px 10px 0 ${({ theme }) => theme.colors.black}26;
  transition: background ${({ theme }) => theme.animation.duration.quick1}
    ${({ theme }) => theme.animation.easing.expressive.standard};

  @media screen and (min-width: ${props => props.theme.breakpoints.xl}) {
    box-shadow: none;
  }
`;

export { NavigationContainer, NavigationSlideAnimation };
//# sourceMappingURL=Navigation.styles.mjs.map
